module.exports = __webpack_public_path__ + "static/img/MM-logo.c64853f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/MM-logo.png
// module id = y+lk
// module chunks = 0